import {CreateTimesheetRequest, UpdateTimesheetRequest} from '../../../../api';
import {TimesheetFormValue} from '../models/timesheet-form-value';

// Create and Update share the same shape; the intersection keeps both call sites honest if they ever diverge.
export function mapFormValueToTimesheetRequest(
  formValue: TimesheetFormValue
): CreateTimesheetRequest & UpdateTimesheetRequest {
  return {
    date: formValue.date,
    // Required by the form validators, so the non-null assertions hold for any value that reaches here.
    startTime: formValue.startTime!,
    endTime: formValue.endTime!,
    timesheetTypeId: formValue.timesheetTypeId!,
    description: formValue.description,
    billingDescription: formValue.billingDescription,
    statusId: formValue.statusId,
    subject: formValue.subject,
    concernedPartyId: formValue.concernedPartyId,
    todoId: formValue.todoId,
    isBillable: formValue.isBillable,
    billableDurationInSeconds: formValue.isBillable
      ? (formValue.billableDurationInMinutes ?? 0) * 60
      : 0,
    mileage: formValue.mileage,
    travelExpensesAmount: formValue.travelExpensesAmount,
    productIds: formValue.productIds,
    activityTypeIds: formValue.activityTypeIds,
  };
}
